import { render, staticRenderFns } from "./setServeInfo.vue?vue&type=template&id=e2e2ced2&scoped=true&"
import script from "./setServeInfo.vue?vue&type=script&lang=js&"
export * from "./setServeInfo.vue?vue&type=script&lang=js&"
import style0 from "./setServeInfo.vue?vue&type=style&index=0&id=e2e2ced2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e2ced2",
  null
  
)

export default component.exports